var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.984.034C44.947.034 28.726 9.97 20.39 25.191a13.307 13.307 0 0 1-.34-3.637c-8.596 1.072-17.344 8.76-20.05 17.539-.01.031.028.055.054.035 5.387-4.116 11.623-5.685 16.362-4.305-.089.307-.185.61-.268.92l-.152.568.415.415-2.232 2.232L25.082 49.86l2.233-2.233.413.413c.507-.136.55-.138 1.263-.344l.18-.002c1.334 4.72-.245 10.863-4.333 16.216-.02.026.004.064.035.054 8.782-2.706 16.467-11.456 17.538-20.05a13.269 13.269 0 0 1-3.588-.329 49.414 49.414 0 0 0 11.01-8.33C58.905 26.183 64 13.969 64 1.052V.034h-1.016zM48.396 33.818c-5.603 5.6-12.398 9.717-19.702 11.846l-.228.002-.12.1-.014.004-10.065-10.064C22.353 21.22 33.22 9.958 46.89 4.933l12.187 12.188a46.395 46.395 0 0 1-10.682 16.697z",
    fill: "#1c2c3d",
    className: "fill-000000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.672,
    cy: 20.295,
    r: 6.642,
    fill: "#1c2c3d",
    className: "fill-000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.036 44.165C9.38 47.819 7.433 56.598 7.433 56.598s8.779-1.949 12.433-5.603l.052-.055-6.828-6.827-.054.052z",
    fill: "#1c2c3d",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.248eb0ce512fa12279b5c0e49d659eb7.svg";
export { ForwardRef as ReactComponent };